import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { queryKeys } from "../queryKeys";
import { AxiosError } from "axios";
import { Request } from "@am-tax/wotc-common";
import { axiosInstance } from "../../utils";

interface Generate8850Args {
    clientId: string;
    entityId: string;
    candidateId: string;
}

export function useGenerate8850() {
    const axios = axiosInstance(),
        queryClient = useQueryClient();

    const toast = useToast();

    return useMutation({
        mutationFn: ({ clientId, entityId, candidateId }: Generate8850Args) =>
            axios.post<Request>(`api/clients/${clientId}/entities/${entityId}/candidates/${candidateId}/generate-8850`).then(response => response.data),
        onSuccess: async (_data, variables) => {
            await queryClient.invalidateQueries(queryKeys.requests.byCandidateId(variables.candidateId).queryKey);
        },
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Unable to generate Form 8850",
                description: `[${axiosError.request?.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
